import { fromJS, Map } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'
import safeIsNaN from '../../utils/safeIsNaN'

const initialState = fromJS({
  users: {},
  resendInvitation: {},
  usersRootFolders: {}
})

function manageUsersReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_ORGANISATION_DONE:
      return state.set('organisation', fromJS(action.organisation))
    case actionTypes.GET_ORGANISATION_ERROR:
      return state.set('getOrganisationError', action.error)

    case actionTypes.GET_USERS_PAGE:
      return state.set('getUsersPage', true)
    case actionTypes.GET_USERS_PAGE_DONE:
      return state
        .set('getUsersPage', false)
        .setIn(['users', action.page], action.users)
    case actionTypes.CLEAR_USERS:
      return state.set('users', new Map())
    case actionTypes.GET_USERS_PAGE_ERROR:
      return state
        .se('getUsersPage', false)
        .set('getUsersPageError', action.error)

    case actionTypes.GET_USER_BY_ID:
      return state.set('user', null).delete('getUserByIdError')
    case actionTypes.GET_USER_BY_ID_DONE:
      return state.set('user', action.user)
    case actionTypes.CLEAR_USER:
      return state.set('user', null)
    case actionTypes.GET_USER_BY_ID_ERROR:
      return state.set('getUserByIdError', action.error)

    case actionTypes.UPDATE_USER:
      return state.set('updatingUser', true)
    case actionTypes.UPDATE_USER_DONE: {
      let newState = state
      let currentUsersPage
      if (!safeIsNaN(action.page) && !safeIsNaN(action.userIndex)) {
        currentUsersPage = state.getIn(['users', action.page])
        currentUsersPage.content[action.userIndex] = action.user
        newState = newState.setIn(['users', action.page], currentUsersPage)
      }
      return newState.set('updatingUser', false)
    }
    case actionTypes.UPDATE_USER_ERROR:
      return state
        .set('updateUserError', action.error)
        .set('updatingUser', false)

    case actionTypes.SAVE_NEW_USER_AVATAR:
      return state.set('savingNewUserAvatar', true)
    case actionTypes.SAVE_NEW_USER_AVATAR_DONE:
      return state.set('savingNewUserAvatar', false)
    case actionTypes.SAVE_NEW_USER_AVATAR_ERROR:
      return state
        .set('saveNewUserAvatarError', action.error)
        .set('savingNewUserAvatar', false)

    case actionTypes.BULK_UPDATE_USERS:
      return state.set('updatingBulk', true)
    case actionTypes.BULK_UPDATE_USERS_DONE: {
      const currentUsersPage = state.getIn(['users', action.page])
      action.keys.forEach((key, index) => {
        currentUsersPage.content[key] = action.users[index]
      })
      return state
        .setIn(['users', action.page], currentUsersPage)
        .set('updatingBulk', false)
    }
    case actionTypes.BULK_UPDATE_USERS_ERROR:
      return state
        .set('updatingBulk', false)
        .set('bulkUpdateUsersError', action.error)

    case actionTypes.INVITE_USER:
      return state.set('inviteUserError', null)
    case actionTypes.INVITE_USER_ERROR:
      return state.set('inviteUserError', action.error)

    case actionTypes.CLEAR_IMPORT_USERS:
      return state.set('columns', null).set('fileId', null)
    case actionTypes.UPLOAD_USERS_FILE_DONE:
      return state.set('columns', action.columns).set('fileId', action.fileId)
    case actionTypes.UPLOAD_USERS_FILE_ERROR:
      return state.set('uploadUsersError', action.error)
    case actionTypes.IMPORT_USERS_ERROR:
      return state.set('importUsersError', action.error)

    case actionTypes.CLEAR_USER_PROJECT_MATRIX:
      return state.delete('userMemberships')
    case actionTypes.GET_USER_PROJECT_MATRIX: {
      let newState = state
      if (action.page === 0) {
        newState = newState.delete('userMemberships')
      }

      return newState.set('gettingUserMemberships', true)
    }
    case actionTypes.GET_USER_PROJECT_MATRIX_DONE: {
      let newState = state

      newState = newState.setIn(
        ['userMemberships', action.page],
        action.memberships
      )

      return newState.set('gettingUserMemberships', false)
    }
    case actionTypes.GET_USER_PROJECT_MATRIX_ERROR:
      return state
        .set('getUserProjectMatrixError', action.error)
        .set('gettingUserMemberships', false)

    case actionTypes.UPDATE_USERS_MEMBERSHIPS_ERROR:
      return state.set('updateUsersMembershipsError', action.error)

    case actionTypes.CLEAR_RESEND_INVITATION:
      return state.set('resendInvitation', fromJS({}))
    case actionTypes.RESEND_INVITATION:
      return state
        .setIn(['resendInvitation', action.userId, 'resending'], true)
        .deleteIn(['resendInvitation', action.userId, 'error'])
    case actionTypes.RESEND_INVITATION_DONE:
      return state.setIn(
        ['resendInvitation', action.userId, 'resending'],
        false
      )
    case actionTypes.RESEND_INVITATION_ERROR:
      return state
        .setIn(['resendInvitation', action.userId, 'error'], action.error)
        .set(['resendInvitation', action.userId, 'resending'], false)

    case actionTypes.GET_COMPANY_NAMES:
      return state
        .set('gettingCompanyNames', true)
        .delete('getCompanyNamesError')
    case actionTypes.GET_COMPANY_NAMES_DONE:
      return state
        .set('companies', action.companies)
        .set('gettingCompanyNames', false)
    case actionTypes.GET_COMPANY_NAMES_ERROR:
      return state
        .set('getCompanyNamesError', action.error)
        .set('gettingCompanyNames', false)

    case actionTypes.ADD_COMPANY_NAME:
      return state
        .set('addingCompanyName', action.companyName)
        .delete('addCompanyNameError')
    case actionTypes.ADD_COMPANY_NAME_DONE:
      return state
        .set('companies', [...state.get('companies'), action.company])
        .set('addingCompanyName', null)
    case actionTypes.ADD_COMPANY_NAME_ERROR:
      return state
        .set('addCompanyNameError', action.error)
        .set('addingCompanyName', null)

    case actionTypes.DELETE_COMPANY_NAME: {
      const companies = state.get('companies')
      companies.splice(action.index, 1)
      return state
        .set('deletingCompanyName', true)
        .delete('deleteCompanyNameError')
        .set('companies', companies)
    }
    case actionTypes.DELETE_COMPANY_NAME_DONE:
      return state.set('deletingCompanyName', false)
    case actionTypes.DELETE_COMPANY_NAME_ERROR:
      return state
        .set('deleteCompanyNameError', action.error)
        .set('deletingCompanyName', false)

    case actionTypes.CHANGE_COMPANY_NAME: {
      const companies = state.get('companies')
      companies[action.index] = action.company
      return state
        .set('changingCompanyName', true)
        .delete('changeCompanyNameError')
        .set('companies', companies)
    }
    case actionTypes.CHANGE_COMPANY_NAME_DONE:
      return state.set('changingCompanyName', false)
    case actionTypes.CHANGE_COMPANY_NAME_ERROR:
      return state
        .set('changeCompanyNameError', action.error)
        .set('changingCompanyName', false)

    case actionTypes.GET_USERS_ROOT_FOLDER:
      return state
        .set('gettingUsersRootFolder', true)
        .delete('getUsersRootFolderError')
    case actionTypes.GET_USERS_ROOT_FOLDER_DONE:
      return state
        .set('gettingUsersRootFolder', false)
        .setIn(['usersRootFolders', action.userId], action.rootFolder)
    case actionTypes.GET_USERS_ROOT_FOLDER_ERROR:
      return state
        .set('getUsersRootFolderError', action.error)
        .set('gettingUsersRootFolder', false)

    case actionTypes.SET_USERS_ROOT_FOLDER:
      return state
        .set('settingUsersRootFolder', true)
        .setIn(['usersRootFolders', action.userId], action.rootFolder)
        .delete('setUsersRootFolderError')
    case actionTypes.SET_USERS_ROOT_FOLDER_DONE:
      return state.set('settingUsersRootFolder', false)
    case actionTypes.SET_USERS_ROOT_FOLDER_ERROR:
      return state
        .set('setUsersRootFolderError', action.error)
        .set('settingUsersRootFolder', false)

    case actionTypes.ASSIGN_LICENSE_TO_USER: {
      let newState = state
      if (!safeIsNaN(action.page) && !safeIsNaN(action.userIndex)) {
        const currentUsersPage = state.getIn(['users', action.page])
        currentUsersPage.content[action.userIndex] = {
          ...currentUsersPage.content[action.userIndex],
          license: {
            ...currentUsersPage.content[action.userIndex].license,
            paid: true
          }
        }
        newState = newState.setIn(['users', action.page], currentUsersPage)

        const pathAvailableAccounts = [
          'organisation',
          'subscription',
          'availableAccounts'
        ]
        newState = newState.setIn(
          pathAvailableAccounts,
          newState.getIn(pathAvailableAccounts) - 1
        )

        const pathUsedAccounts = [
          'organisation',
          'subscription',
          'usedAccounts'
        ]
        newState = newState.setIn(
          pathUsedAccounts,
          newState.getIn(pathUsedAccounts) + 1
        )
      }
      return newState
        .set('assigningLicenseToUser', true)
        .delete('assignLicenseToUserError')
    }
    case actionTypes.ASSIGN_LICENSE_TO_USER_DONE:
      return state.set('assigningLicenseToUser', false)
    case actionTypes.ASSIGN_LICENSE_TO_USER_ERROR:
      return state
        .set('assignLicenseToUserError', action.error)
        .set('assigningLicenseToUser', false)

    case actionTypes.REMOVE_LICENSE_FROM_USER: {
      let newState = state
      if (!safeIsNaN(action.page) && !safeIsNaN(action.userIndex)) {
        const currentUsersPage = state.getIn(['users', action.page])
        currentUsersPage.content[action.userIndex] = {
          ...currentUsersPage.content[action.userIndex],
          license: {
            ...currentUsersPage.content[action.userIndex].license,
            paid: false
          }
        }
        newState = newState.setIn(['users', action.page], currentUsersPage)

        const pathAvailableAccounts = [
          'organisation',
          'subscription',
          'availableAccounts'
        ]
        newState = newState.setIn(
          pathAvailableAccounts,
          newState.getIn(pathAvailableAccounts) + 1
        )

        const pathUsedAccounts = [
          'organisation',
          'subscription',
          'usedAccounts'
        ]
        newState = newState.setIn(
          pathUsedAccounts,
          newState.getIn(pathUsedAccounts) - 1
        )
      }
      return newState
        .set('removingLicenseFromUser', true)
        .delete('removeLicenseFromUserError')
    }
    case actionTypes.REMOVE_LICENSE_FROM_USER_DONE:
      return state.set('removingLicenseFromUser', false)
    case actionTypes.REMOVE_LICENSE_FROM_USER_ERROR:
      return state
        .set('removeLicenseFromUserError', action.error)
        .set('removingLicenseFromUser', false)
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default manageUsersReducer
